<!-- components/GameJackpot.vue -->
<script setup>
defineOptions({
  name: 'GameJackpot'
});

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { usePlayerStore } from '../stores/player/playerStore';
import { api } from '../services/api'; // Importar publicApi directamente

const playerStore = usePlayerStore();

const currency_prefix = computed(() => playerStore.currencyPrefix);

const JACKPOT_LEVELS = ['iron', 'bronze', 'silver', 'gold', 'platinum', 'diamond'];

const showJackpots = ref(false);
let timeoutId = null;
let updateIntervalId = null;
const localJackpots = ref([]); // Estado local para jackpots



// En la función loadJackpots:
const loadJackpots = async () => {
  try {
    console.log('🎯 Cargando jackpots con autenticación...');
    
    // Cambiar de publicApi a api
    const response = await api.get('/jackpots');
    console.log('🎯 Respuesta de jackpots autenticada:', response.data);
    
    if (response.data.jackpots) {
      localJackpots.value = response.data.jackpots;
    }
  } catch (error) {
    console.error('Error cargando jackpots:', error);
  }
};

// Getter para obtener jackpots por nivel desde estado local
const localJackpotsByLevel = computed(() => {
  return {
    iron: localJackpots.value.find(j => j?.level === 1),
    bronze: localJackpots.value.find(j => j?.level === 2),
    silver: localJackpots.value.find(j => j?.level === 3),
    gold: localJackpots.value.find(j => j?.level === 4),
    platinum: localJackpots.value.find(j => j?.level === 5),
    diamond: localJackpots.value.find(j => j?.level === 6)
  };
});

const toggleJackpots = () => {
  showJackpots.value = !showJackpots.value;
  
  if (showJackpots.value) {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      showJackpots.value = false;
    }, 5000);
  }
};

onMounted(async () => {
  console.log('🎰 GameJackpot montado, cargando jackpots directamente...');
  
  // Cargar jackpots directamente
  await loadJackpots();
  
  // Configurar actualización periódica
  updateIntervalId = setInterval(() => {
    console.log('🎰 Actualizando jackpots periódicamente...');
    loadJackpots();
  }, 15000); // Actualizar cada 15 segundos
});

onUnmounted(() => {
  if (timeoutId) clearTimeout(timeoutId);
  if (updateIntervalId) clearInterval(updateIntervalId);
});
</script>

<template>
  <div class="jackpots" :class="{ 'show-dropdown': showJackpots }">
    <span class="dropdown-trigger" @click="toggleJackpots">Jackpots ▼</span>
    
    <template v-for="level in JACKPOT_LEVELS" :key="level">
      <div v-if="localJackpotsByLevel[level]" :class="['jackpot', level]">
        {{ level.toUpperCase() }} {{ currency_prefix }}
        <span class="jackpot-value">
          {{ Number(localJackpotsByLevel[level]?.current_balance).toFixed(2) }}
          <span v-if="localJackpotsByLevel[level]?.is_mystery_mode" class="mystery-fire">🔥</span>
        </span>
      </div>
    </template>
  </div>
</template>

<style scoped>
@import '../assets/styles/main.css';
</style>